import type { FlatConfig } from './flatConfig';

export interface Pricing {
  subscriptionMonths: number;
  serviceOption: string;
  quarter: string;
  discountMonths: number;
  ssdSoftware: number;
  hddSoftware: number;
  baseSsdSoftware: number;
  baseHddSoftware: number;
  ssdLicenseUnitPrice: number;
  ssdSupportUnitPrice: number;
  hddLicenseUnitPrice: number;
  hddSupportUnitPrice: number;
}

export function pricingFromFlat(c: FlatConfig): Pricing {
  return {
    subscriptionMonths: c.subscriptionMonths,
    serviceOption: c.serviceOption,
    quarter: c.quarter,
    discountMonths: c.discountMonths,
    ssdSoftware: c.ssdSoftware,
    hddSoftware: c.hddSoftware,
    baseSsdSoftware: c.baseSsdSoftware,
    baseHddSoftware: c.baseHddSoftware,
    ssdLicenseUnitPrice: c.ssdLicenseUnitPrice,
    ssdSupportUnitPrice: c.ssdSupportUnitPrice,
    hddLicenseUnitPrice: c.hddLicenseUnitPrice,
    hddSupportUnitPrice: c.hddSupportUnitPrice,
  };
}

export function pricingToFlat(p: Pricing): Pick<FlatConfig, keyof Pricing> {
  return { ...p };
}
